<template>
  <v-card
    class="mx-auto pt-5 EK-card rounded-xl rounded-tl-0 IMThemeGray store-action-form"
  >
    <v-card-title class="justify-content-center IMThemeOrange py-3 rounded-0 text-white"
      ><strong>إشعار</strong></v-card-title
    >
    <v-card-text class="text-right pt-4">
      <div>
        <label>عنوان الإشعار</label>
        <v-textarea
          class="ma-0 pa-0"
          rounded
          solo
          readonly
          v-model="orderDto.title"
        ></v-textarea>
      </div>
      <div>
        <label>نص الإشعار</label>
        <v-textarea
          color="secondary"
          id="description"
          rounded
          readonly
          solo
          v-model="orderDto.description"
        ></v-textarea>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-btn class="mx-auto px-8" @click="dialog = true" rounded> إرسال </v-btn>
      <v-btn
        class="mx-auto px-8"
        @click="onConfirmDelete(orderDto.id, orderIndex)"
        rounded
      >
        حذف
        <img src="/media/svg/table/delete.svg" alt="delete" class="pr-2" />
      </v-btn>
    </v-card-actions>

    <v-dialog v-model="dialog" width="500" scrollable>
      <v-card class="IMThemeGray">
        <v-card-title class="headline text-center justify-content-center">
          <h5 class="m-0 text-white">تأكيد الإشعار</h5>
        </v-card-title>
        <v-card-text class="text-right pt-4">
          <div>
            <label>عنوان الإشعار</label>
            <v-textarea
              class="ma-0 pa-0"
              rounded
              solo
              v-model="orderDto.title"
            ></v-textarea>
          </div>
          <div>
            <label>نص الإشعار</label>
            <v-textarea
              color="secondary"
              id="description"
              rounded
              solo
              v-model="orderDto.description"
            ></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="success"
            @click="
              transferToNotification({
                order: orderDto,
                index: orderIndex,
              });
              dialog = false;
            "
          >
            تم
          </v-btn>
          <v-btn color="light" text outlined @click="dialog = false"> إلغاء </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-actions>
      <v-btn
        @click="isShowSMS()"
        dark
        color="IMThemeOrange"
        rounded
        class="rounded-tl-0 px-6 mx-auto"
      >
        إرسال رسالة SMS
      </v-btn>
    </v-card-actions>
    <v-dialog v-model="showSMS" width="1000px">
      <orderHandlerModal :smsDto="orderDto.smsDto" @close="isShowSMS()" />
    </v-dialog>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import orderHandlerModal from "@/components/orderHandlerModal.vue";
export default {
  data: () => ({
    dialog: false,
    showSMS: false,
  }),
   components: {
    orderHandlerModal,
  },
  props: {
    orderIndex: String,
  },
  created() {
    this.getOrderDetails(this.orderIndex);
    this.offset = this.getOffset(document.querySelector(".store-action-form")).top;
    setTimeout(() => {
      window.scrollTo(this.offset, this.offset);
    }, 100);
  },
  computed: {
    ...mapGetters(["orderDto"]),
  },
  methods: {
    getOffset(el) {
      var _x = 0;
      var _y = 0;
      while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
        _x += el.offsetLeft - el.scrollLeft;
        _y += el.offsetTop - el.scrollTop;
        el = el.offsetParent;
      }
      return { top: _y, left: _x };
    },
    ...mapActions(["deleteOrdersStore", "getOrderDetails", "transferToNotification"]),
    onConfirmDelete(id, index) {
      this.deleteOrdersStore({ id, index });
    },
    isShowSMS() {
      this.showSMS = !this.showSMS;
    },
  },
  watch: {
    orderIndex(index) {
      this.getOrderDetails(index);
      this.offset = this.getOffset(document.querySelector(".store-action-form")).top;
      setTimeout(() => {
        window.scrollTo(this.offset, this.offset);
      }, 100);
    },
  },
};
</script>
